module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/assessment_achievements/1_3785dfcddd91914057018070ed2c0bfd.png";